export var applyThousandsSeparator = function (value, separator) {
    if (separator === void 0) { separator = '.'; }
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
};
